import { CredentialField } from "../shared/CredentialField";

export const MixpanelCredentialsForm = ({
  credentials,
  onCredentialsChange,
}) => {
  const handleChange = (field) => (value) => {
    onCredentialsChange((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="px-6 pb-4">
      <h3 className="mb-2 text-lg font-semibold text-gray-900">
        Enter your Mixpanel credentials
      </h3>
      <p className="mb-4 text-sm text-gray-500">
        You&apos;ll need your Project ID and Service Account credentials from
        Mixpanel. Create a service account in Mixpanel Settings &gt; Service
        Accounts.
      </p>

      <div className="space-y-4">
        <CredentialField
          id="mixpanel_project_id"
          label="Project ID"
          tooltip="Find this in Mixpanel Settings > Project Settings"
          placeholder="Enter your Mixpanel Project ID"
          value={credentials.project_id}
          onChange={handleChange("project_id")}
        />
        <CredentialField
          id="mixpanel_service_account_username"
          label="Service Account Username"
          tooltip="Create a service account in Mixpanel Settings > Service Accounts"
          placeholder="Enter service account username"
          value={credentials.service_account_username}
          onChange={handleChange("service_account_username")}
        />
        <CredentialField
          id="mixpanel_service_account_password"
          label="Service Account Password"
          type="password"
          tooltip="The secret associated with your service account"
          placeholder="Enter service account password"
          value={credentials.service_account_password}
          onChange={handleChange("service_account_password")}
        />
      </div>
    </div>
  );
};
